import React from "react";
import PropTypes from "prop-types";
import LoggedInAs from "./LoggedInAs";
import { useSelector, useDispatch } from "react-redux";
import { MinusIcon } from "@heroicons/react/20/solid";

import NewLoginCreateAccount from "../../new-login-create-account/NewLoginCreateAccount.jsx";
import { loginUser, setSubscription } from "../redux/slices/userSlice";
import { setPageStatus, setShowToast } from "../redux/slices/navSlice";

const AccountForms = ({ country }) => {
  const dispatch = useDispatch();
  const countryCode = useSelector(
    (state) => state.company.presenter.country_code,
  );
  const dataCountry = useSelector(
    (state) => state.company.presenter.data_country,
  );
  const user = useSelector((state) => state.user);
  const pageStatus = useSelector((state) => state.nav.pageStatus);

  const setUser = (user, shouldShowToast) => {
    dispatch(setShowToast(shouldShowToast));
    dispatch(loginUser(JSON.stringify(user)));
    dispatch(setSubscription(user.subscription_level_id));
    if (pageStatus === "gift_page_2") {
      dispatch(setPageStatus("payment"));
    }
  };
  if (user.loadingUser === "pending") {
    return (
      <div className="account-spinner">
        <MinusIcon className="loading-spinner" />
      </div>
    );
  } else if (user.user) {
    return <LoggedInAs user={JSON.parse(user.user)} />;
  } else {
    return (
      <NewLoginCreateAccount
        country={country || "US"}
        setUser={setUser}
        siteArea={"purchase_credit_checkout"}
      />
    );
  }
};

export default AccountForms;

AccountForms.propTypes = {
  country: PropTypes.string,
};

AccountForms.defaultProps = {
  country: "US",
};
